module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ProdutosCadastrados')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88e0dc9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Estoque.vue
// module id = 300
// module chunks = 1